<script setup lang="ts">

import { useFetchGeneral } from '~/api/service/general/index.service'
import HomeChartTitle from '~/components/@pages/home/HomeChartTitle.vue'
import LineChart from '~/components/chart/LineChart.vue'
import CustomSuspense from '~/components/suspense/CustomSuspense.vue'
import IconTooltip from '~/components/tooltip/IconTooltip.vue'
import { HOME_CHART_TOOLTIP } from '~/constants/general.const'
import { IMAGE_BASE_URL } from '~/constants/image.constant'
import { UNIT } from '~/environment-variables/unit.const'
import { generalParamType } from '~/types/general.type'

const { data, isLoading } = useFetchGeneral([ generalParamType.BURNT_FEE ])

const burntFee = computed(() => {
  if (!data.value) return ''
  return setComma(data.value.FBFI.OBJ.TBF)
})

const lineChartList = computed(() => {
  if (!data.value) return []
  return data.value.FBFI.OBJ.DBFLIST.map(i => {
    return [ i.UT, i.CNT ]
  })
})
</script>

<template>
  <div>
    <CustomSuspense :is-loading="isLoading">
      <template #loading>
        <img
          :src="`${IMAGE_BASE_URL}/skeleton/home/line-chart.png`"
          alt="gas fees chart skeleton"
        >
      </template>
      <template #default>
        <Card class="flex h-full flex-col justify-between pt-5">
          <div class="flex flex-col gap-y-2 px-5">
            <HomeChartTitle
              title="Daily Gas Fees"
              :tooltip="HOME_CHART_TOOLTIP[generalParamType.BURNT_FEE]"
            />
            <strong class="text-3xl text-primary">{{ burntFee }} <span class="text-primary/40 text-lg">{{ UNIT }}</span></strong>
          </div>
          <LineChart
            :height="144"
            line-color="#ff74fd"
            gradient-color="#ff74fd"
            :data="lineChartList"
            :formatter="(params) => {
              return `<p class='text-center'><span class='text-white/40'>${params[0].name}</span><br />Gas Fees: ${setComma(params[0].value)} ${UNIT}</p>`
            }"
          />
        </Card>
      </template>
    </CustomSuspense>
  </div>
</template>

<style scoped>

</style>